module.exports = __webpack_public_path__ + "static/media/icon-offer-sell.78d67c1d.svg";